const INITIAL_STATE = {
  activeModal: { 
    employee: false,
    modal: false,
  },
  stepEmployeePassword: 1
};

export default function employeeReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case "ACTIVE_EMPLOYEE_MODAL": 
      return {
        ...state,
        activeModal: action.activeModal
      }
    case 'STEP_EMPLOYEE': 
      return {
        ...state,
        stepEmployeePassword: action.step
      };
    default:
      return state;
  }
}